import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  CreateFacultyGroupAPI,
  DeleteFacultyGroupAPI,
  ListFacultyGroupsAPI,
  UpdateFacultyGroupAPI,
} from "./facultyGroups.api";

export const facultyGroupsKeys = {
  all: ["faculty-groups"],
  lists: () => [...facultyGroupsKeys.all, "list"],
  list: (params) => [...facultyGroupsKeys.lists(), params],
};

export const useFacultyGroupsListQuery = (params, options = {}) =>
  useQuery({
    queryKey: facultyGroupsKeys.list(params),
    queryFn: () => ListFacultyGroupsAPI(params),
    ...options,
  });

export const useCreateFacultyGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: CreateFacultyGroupAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyGroupsKeys.lists() });
    },
  });
};

export const useUpdateFacultyGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateFacultyGroupAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyGroupsKeys.lists() });
    },
  });
};

export const useDeleteFacultyGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DeleteFacultyGroupAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyGroupsKeys.lists() });
    },
  });
};
